// Unit conversion for production requirements. Converts a quantity between
// compatible units (mass, volume, count). Returns null when units are
// incompatible so callers can fall back safely.
const FAMILIES = [
  { base: "g", map: { mg: 0.001, g: 1, gm: 1, gms: 1, gram: 1, grams: 1, kg: 1000, kgs: 1000, kilogram: 1000, kilograms: 1000 } },
  { base: "ml", map: { ml: 1, cl: 10, l: 1000, ltr: 1000, litre: 1000, litres: 1000, liter: 1000, liters: 1000 } },
  { base: "pcs", map: { pc: 1, pcs: 1, piece: 1, pieces: 1, nos: 1, no: 1, unit: 1, units: 1, dozen: 12, doz: 12 } },
];

const norm = (u) => String(u || "").trim().toLowerCase();

export function convertQty(qty, from, to) {
  const f = norm(from), t = norm(to);
  const n = Number(qty) || 0;
  if (!f || !t || f === t) return n;
  for (const fam of FAMILIES) {
    if (f in fam.map && t in fam.map) return n * (fam.map[f] / fam.map[t]);
  }
  return null; // incompatible (e.g. pkt vs g)
}

// Convert if possible, else return the original quantity unchanged.
export function convertQtyOr(qty, from, to) {
  const v = convertQty(qty, from, to);
  return v == null ? (Number(qty) || 0) : v;
}
